import React, { useState } from 'react';
const faqs = [{
  q: 'How does Cricket Ready work?',
  a: 'Downloadable digital system. Instant access to all PDFs after purchase. Open on any device, start coaching immediately.'
}, {
  q: 'Does it work for any age group?',
  a: 'Yes. Covers U8 through U18 with age-appropriate sessions, progressions, and drills.'
}, {
  q: 'Can I edit the material?',
  a: 'PDFs are ready-to-use, designed to be printed, annotated, and taken directly to the ground.'
}, {
  q: 'Are the bonuses included in the price?',
  a: 'Yes — all 5 bonuses included in the one-time $27 price. No upsells, no hidden extras.'
}, {
  q: 'Is it suitable for beginner coaches?',
  a: 'Absolutely. A first-year coach can open it today and run a structured, professional session this week.'
}, {
  q: 'Is it useful for school PE teachers too?',
  a: 'Yes. PE teachers, school sport coordinators and community coaches all benefit.'
}, {
  q: 'How long does access last?',
  a: 'Lifetime access. Files are yours to keep and download as many times as you need.'
}, {
  q: 'What makes this different from other coaching resources?',
  a: 'Most coaching resources give you theory. Cricket Ready gives you a complete system — 50 sessions you can run today, progressions that build on each other, and planning tools that save hours every week. Inspired by ECB and Cricket Australia development programmes.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-white py-16 px-4" data-id="element-35">
      <div className="max-w-3xl mx-auto" data-id="element-36">
        <h2 className="text-3xl sm:text-4xl font-black text-[#0A0A0A] text-center mb-10 tracking-tight" data-id="element-37">
          Frequently Asked <span className="text-[#d4af37]" data-id="element-38">Questions</span>
        </h2>

        <div className="bg-white border border-[#E5E5EA] rounded-2xl divide-y divide-[#E5E5EA] overflow-hidden shadow-sm" data-id="element-39">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="bg-[#FAFAFA] hover:bg-white transition-colors" data-id="element-40">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-41">
                  <span className="text-[#0A0A0A] font-black text-base" data-id="element-42">
                    {faq.q}
                  </span>
                  <span className={`text-[#d4af37] text-xl font-black flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-45' : ''}`} data-id="element-43">
                    +
                  </span>
                </button>
                {isOpen && <div className="px-6 pb-5 -mt-2" data-id="element-44">
                    <p className="text-[#5A5A66] text-sm sm:text-base font-medium leading-relaxed" data-id="element-45">
                      {faq.a}
                    </p>
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}